import { observer } from 'mobx-react-lite';
import styles from './index.module.scss';
import EMRPatientInfo from './EMRPatientInfo';
import { useNavigate } from 'react-router';
import { Button } from '@mui/material';
import { ReactComponent as WarningIcon } from '../../../../../../../assets/icons/thinWarningIcon.svg';
import classNames from 'classnames';
import { IEMRPatient } from '../../../../../../../services/intakeDataService/emrPatientsService/types';
import useQueryParam from '../../../../../../../hooks/useCustomQueryParam';

const DuplicatedEMRResult = ({
  patient,
  patientUuid,
}: {
  patient: IEMRPatient;
  patientUuid: string;
}) => {
  const navigate = useNavigate();
  const [, setNewPatient] = useQueryParam<string | undefined>('newPatientUuid');
  return (
    <div
      className={classNames(
        'rounded-8 p-4 gap-4 flex flex-col',
        styles.duplicateResultWrapper,
      )}
    >
      <div className={classNames('flex flex-col', styles.title)}>
        <div className="flex l font-semibold leading-normal items-center">
          <WarningIcon className="mr-2" /> Results already in OneStep
        </div>
        <div className="text-base">
          These results are already imported to the OneStep platform. To view a patient’s file,
          click "Go to patient"
        </div>
      </div>
      <div
        className={classNames(
          styles.duplicatedPatient,
          'flex items-center rounded-8 bg-white p-4 justify-between',
        )}
      >
        <EMRPatientInfo {...patient} />
        <Button
          className="text-xs font-semibold"
          onClick={() => {
            setNewPatient(undefined);
            navigate(`/patients/${patientUuid}/`);
          }}
          variant={'outlined'}
          color={'primary'}
          role="link"
        >
          Go to patient
        </Button>
      </div>
    </div>
  );
};
export default observer(DuplicatedEMRResult);
